import { IGroupFixture } from "core-integration/src/store/fixtures/types";
import { matchStatsContainer, statsList } from "../fixtureStats.css";
import Stat from "./Stat";

interface MatchStatsProps {
  fixture: IGroupFixture;
}

const MatchStats = ({ fixture }: MatchStatsProps) => {
  // Our render stats should contain only stats with data and a maximum
  // of 5 per team of BPS
  const renderStats = fixture.stats
    .filter((stat) => stat.h.length || stat.a.length)
    .map((stat) =>
      stat.identifier === "bps"
        ? {
            identifier: stat.identifier,
            h: stat.h.slice(0, 5),
            a: stat.a.slice(0, 5),
          }
        : stat,
    );

  return (
    <div className={matchStatsContainer}>
      <ul className={statsList}>
        {renderStats.map((stat) => (
          <Stat key={stat.identifier} stat={stat} />
        ))}
      </ul>
    </div>
  );
};

export default MatchStats;
